<template>
  <router-view :key="routerViewKey" />
</template>
<script>
import { mapState } from 'vuex'

export default {
  name: 'EmptyLayout',
  computed: {
    ...mapState('time', ['current']),
    routerViewKey() {
      return `${this.$route.fullPath}&t=${this.current}`
    },
  },
}
</script>
